import classNames from 'classnames'
import { type FC } from 'react'
import { Form } from 'react-bootstrap'
import { PiiRedactionBadge } from './PiiRedactionBadge'
import { type PiiEntity, type PiiEntityDefinition } from '../../../../common/piiShieldCategories'

interface PiiShieldEntityRowProps {
  entity: PiiEntityDefinition
  isEditMode: boolean
  isRedacted: boolean
  isFirst: boolean
  onToggle: (entity: PiiEntity) => void
}

export const PiiShieldEntityRow: FC<PiiShieldEntityRowProps> = ({ entity, isEditMode, isRedacted, isFirst, onToggle }) => (
  <div
    className={classNames('d-flex align-items-center zocks-gap-0.5 zocks-pt-0.75 zocks-pb-0.75 mx-4 ps-4', {
      'border-top zocks-border-color-gray-300': !isFirst,
    })}
  >
    {isEditMode ? (
      <div className='pii-shield-checkbox'>
        <Form.Check
          type='checkbox'
          id={`pii-entity-${entity.value}`}
          checked={isRedacted}
          onChange={() => onToggle(entity.value)}
          aria-label={entity.label}
          className='d-flex justify-content-center'
        />
      </div>
    ) : null}
    <span className={classNames('flex-grow-1 paragraph-medium', isRedacted ? 'zocks-text-gray-900' : 'zocks-text-gray-600')}>{entity.label}</span>
    <PiiRedactionBadge redacted={isRedacted} />
  </div>
)
